<template>
  <div class="ptt-20">
    <show-time :showTime="showtimes" ref="shtime" @showselected="shows"></show-time>

    <p class="description ptt-20 movp" v-if="movieDetail.description"> {{ movieDetail.description }}</p>

    <ul class="features">
      <!-- <li>
        <div class="rate">
          <svg class="circle-chart" viewBox="0 0 30 30" width="40" height="40" fill="transparent"
            xmlns="http://www.w3.org/2000/svg">
            <circle class="circle-chart__background" stroke="#eee" stroke-width="2" fill="none" cx="15" cy="15" r="14">
            </circle>
            <circle class="circle-chart__circle" stroke="#4eb04b" stroke-width="2" stroke-dasharray="50,100" cx="15"
              cy="15" r="14"></circle>
          </svg>
          <b>5.4</b> Rating
        </div>
      </li> -->
      <li>
        <div class="year" v-if="movieDetail.td == null"> 2D</div>
        <div class="year" v-if="movieDetail.td != null"> 3D</div>

      </li>

      <li>
        <div class="tags" v-if="movieDetail.tag">{{ movieDetail.tag }}</div>
      </li>
    </ul>

    <!-- <a href="#" class="add-btn">+ ADD YOUR LIST</a>  -->
    <div>
      <div></div>
    </div>

    <!-- <div class="rate-box mar0">
      <a href="#"><i class="lni lni-thumbs-up"></i></a> <a href="#"><i class="lni lni-thumbs-down"></i></a> <strong>61%
        liked this film</strong>
    </div> -->
  </div>
</template>

<script>
import ShowTime from './ShowTime.vue';

export default {
  props: {
    movieDetail: Object,
    showtimes: null,

  },
  methods:{
    shows(selected,ison){
      this.$emit('selectedshows',selected,ison);
    },

  },

  components: { ShowTime },
  emits:["selectedshows"]
}
</script>